const COMPANY_PATH = /\/companies\/(\d+)/

/**
 * The announcements provider sits outside the router, so the company the user is working
 * in is read from the address rather than from route parameters. The desktop build
 * routes through the hash, which is why both are looked at.
 */
export function resolveCompanyFromLocation(location) {
    const [, fromPath] = COMPANY_PATH.exec(location?.pathname ?? '') ?? []
    const [, fromHash] = COMPANY_PATH.exec(location?.hash ?? '') ?? []
    const found = fromPath ?? fromHash

    return found == null ? null : Number(found)
}
